import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, Suspense as _Suspense, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e85cca06"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "LogicalReasoningRenderContainer"
};
const _hoisted_2 = {
  class: "ft20"
};
const _hoisted_3 = {
  class: "ans-box"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, " 题目图预览 ", -1));
const _hoisted_5 = {
  class: "flex flex-col"
};
const _hoisted_6 = {
  class: "left"
};
const _hoisted_7 = {
  class: "flex items-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_IceCubeItem = _resolveComponent("IceCubeItem");
  const _component_el_image = _resolveComponent("el-image");
  return $props.data ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_2, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1)]),
    _: 1
  }), _createVNode(_component_el_divider, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.activeTab === 'problem' ? '题目预览' : '选项预览'), 1)]),
    _: 1
  }), (_openBlock(), _createBlock(_Suspense, null, {
    default: _withCtx(() => [(_openBlock(), _createBlock(_component_IceCubeItem, {
      onOnSaveImage: $options.handleSaveImage,
      "preview-images": $data.previewData[$props.data.questionIndex],
      "local-index": 0,
      "is-desc": "",
      cubePositions: $props.data.question,
      subject: $props.subject,
      key: `question_${$props.data.questionIndex}_${$options.hash($props.data.question)}`,
      viewPoint: $props.data.viewPoints && Array.isArray($props.data.viewPoints) ? $props.data.viewPoints[0] : null
    }, null, 8, ["onOnSaveImage", "preview-images", "cubePositions", "subject", "viewPoint"]))]),
    _: 1
  })), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_divider, null, {
    default: _withCtx(() => [_createTextVNode("正确答案 " + _toDisplayString($props.data.rightAnswer), 1)]),
    _: 1
  }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.answers, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: `${$props.data.questionIndex}_${index}_${$options.hash($props.data.question)}`,
      class: "item-box"
    }, [_createVNode(_component_el_row, {
      class: "bothCenter"
    }, {
      default: _withCtx(() => [_createElementVNode("span", null, "选项 " + _toDisplayString($data.letters[index]), 1)]),
      _: 2
    }, 1024), _createVNode(_component_IceCubeItem, {
      onOnSaveImage: $options.handleSaveImage,
      "preview-images": $data.previewData[$props.data.questionIndex],
      "local-index": index,
      "is-desc": false,
      subject: $props.subject,
      cubePositions: item,
      viewPoint: $props.data.viewPoints ? $props.data.viewPoints[index + 1] : null
    }, null, 8, ["onOnSaveImage", "preview-images", "local-index", "subject", "cubePositions", "viewPoint"])]);
  }), 128))]), _createVNode(_component_el_divider), _hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_image, {
    style: {
      "height": "120px"
    },
    src: $data.previewData[$props.data.questionIndex]?.question ?? ''
  }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.previewData[$props.data.questionIndex]?.answers, (item, index) => {
    return _openBlock(), _createBlock(_component_el_image, {
      style: {
        "height": "120px",
        "margin-right": "10px"
      },
      key: index,
      src: item ?? ''
    }, null, 8, ["src"]);
  }), 128))])])])) : _createCommentVNode("", true);
}